<template>
	<main class="mypage icon_page">
		<article class="iconInfo">
			<section class="icon_form">
				<div class="icon_wrapper">
					<img src="@/assets/img/mypage/exit.png" alt="회원 탈퇴 완료 아이콘" loading="lazy" />
					<div class="icon_title">
						<p>회원탈퇴가 완료되었습니다.</p>
						<p>그동안 대가의 선택을 이용해주셔서 감사합니다.</p>
					</div>
				</div>
				<div class="c_fieldArea">
					<button class="c_button radius-x-small primary-fill save" @click="$router.replace('/')">홈으로가기</button>
				</div>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.icon_page {
	padding: 22.65rem 2rem;
}
</style>
